export const maxUploadSizeMb = 150; // also configure in server
export const saveDelayMs = 1000;
export const salesforceTimeZone = 'America/New_York';
export const maxThumbnailsTries = 5;
export const featureFlags = {
  userRegistration: 'user-registration',
  microsoftLogin: 'microsoft-login',
  showDiligenceStatus: 'show-diligence-status',
  showNewClientTech: 'underwriting-new-tech',
};
export const emailConfirmations = true; // also configure in server

export const serverUri = process.env.REACT_APP_SERVER_URI;
export const launchDarklyClientSideId = process.env.REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID;
export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const compplexGraphqlApiUrl = process.env.REACT_APP_COMPPLEX_GRAPHQL_URI;

export const googleMapsVersion = process.env.NODE_ENV === 'production' ? 'quarterly' : 'weekly';

export const amplitudeApiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;
